<template>
  <div
    class="lang-row-root"
    :class="type === 'outline' ? 'lang-row-root--outline' : 'lang-row-root--flags'"
  >
    <template v-if="type === 'outline'">
      <v-chip
        v-for="(lang, index) in visibleCountries"
        :key="lang"
        label
        class="countries-outline-chip"
        :outlined="!(fillFirst && index === 0)"
        :color="color"
      >
        {{ lang }}
      </v-chip>
      <v-chip
        v-if="hiddenCountriesCount > 0"
        label
        outlined
        class="countries-outline-chip"
        :color="color"
      >
        +{{ hiddenCountriesCount }}
      </v-chip>
    </template>
    <template v-else>
      <lang-circle
        v-for="lang in visibleCountries"
        :key="lang"
        :country="lang"
        class="countries-flag"
      />
      <div
        v-if="hiddenCountriesCount > 0"
        class="countries-flag-empty"
      >
        +{{ hiddenCountriesCount }}
      </div>
    </template>
  </div>
</template>

<script>
  import { localeToIsoPrefix, mapperIsoLangToOurLocal } from '@/components/core/SelectLang/mapperIsoLocale'
  import LangCircle from '@/components/core/SelectLang/LangRow/LangCircle.vue'

  export default {
    name: 'LangRow',
    components: { LangCircle },
    props: {
      countries: {
        type: Array,
        require: true
      },
      maxItems: {
        type: Number,
        default: 7
      },
      type: {
        type: String,
        default: 'flags',
      },
      color: {
        type: String,
        default: 'grey',
      },
      fillFirst: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      mapperIsoLangToOurLocal
    },
    computed: {
      normalizedCountries () {
        return this.uniqIsoLocale(this.countries)
      },
      visibleCountries () {
        return this.normalizedCountries.slice(0, this.maxItems)
      },
      hiddenCountriesCount () {
        return Math.max(this.normalizedCountries.length - this.maxItems, 0)
      },
      uniqIsoLocale () {
        return (locales) => {
          return Array.from(new Set(locales.map((locale) => this.mapperIsoLangToOurLocal(localeToIsoPrefix(locale)))))
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .lang-row-root {
    &--flags {
      display: flex;
      align-items: center;
      width: 160px;
    }

    &--outline {
      display: inline-flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      width: auto;

      ::v-deep .v-chip {
        box-sizing: border-box;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 27px !important;
        height: 24px !important;
        margin: 0 0 0 -4px;
        padding: 8px 7px !important;
        border-radius: 8px !important;
        text-transform: uppercase;
      }

      ::v-deep .v-chip:first-child {
        margin-left: 0;
      }

      ::v-deep .v-chip .v-chip__content {
        max-width: none !important;
        justify-content: center;
        align-items: center;
        padding: 0 !important;
        margin: 0 !important;
        font-size: 10px;
        line-height: 1;
      }

      ::v-deep .v-chip.v-chip--outlined {
        background-color: #fff !important;
      }
    }
  }

  .countries-flag {
    margin-left: -8px;

    &-empty {
      justify-content: center;
      color: #4F4F4F;
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      margin-left: -8px;
      background: #F2F2F2;
      border-radius: 50%;
    }
  }
</style>
